import { theme } from "../components/theme"

export type ColorVariant = "light" | "dark" | "blue" | "yellow" | "red" | "green" | "light_transparent"

export type ButtonSize = "big" | "normal" | "small"

export const isColorfulVariant = (variant: ColorVariant | undefined) =>
  variant && variant !== "light" && variant !== "dark"

export const getVariantTextColor = (variant: ColorVariant | undefined, size: ButtonSize = "normal"): string => {
  if (isColorfulVariant(variant) && size === "big") {
    return theme.colors.greyDark
  }

  switch (variant) {
    default:
    case "dark":
    case "blue":
    case "green":
    case "red":
      return theme.colors.white
    case "yellow":
    case "light":
      return theme.colors.greyDark
  }
}

export const getVariantColor = (variant: ColorVariant | undefined): string => {
  switch (variant) {
    default:
    case "dark":
      return theme.colors.greyDark
    case "light":
      return theme.colors.white
    case "blue":
      return theme.gradients.blue
    case "green":
      return theme.gradients.green
    case "red":
      return theme.gradients.red
    case "yellow":
      return theme.gradients.yellow
  }
}

export const getVariantHoverColor = (variant: ColorVariant | undefined): string => {
  switch (variant) {
    default:
    case "dark":
      return theme.colors.greyDarker
    case "light":
      return theme.colors.background
    case "blue":
      return theme.gradients.blue
    case "green":
      return theme.gradients.green
    case "red":
      return theme.gradients.red
    case "yellow":
      return theme.gradients.yellow
    case "light_transparent":
      return theme.colors.greyDark
  }
}

export const getVariantBorderColor = (variant: ColorVariant | undefined): string => {
  switch (variant) {
    default:
    case "dark":
      return theme.colors.greyDark
    case "light":
      return theme.colors.greyDarker
    case "blue":
      return theme.gradients.blueBorder
    case "green":
      return theme.gradients.greenBorder
    case "red":
      return theme.gradients.redBorder
    case "yellow":
      return theme.gradients.yellowBorder
  }
}

export const getButtonSizePadding = (size?: ButtonSize, noText = false) => {
  switch (size) {
    default:
    case "small":
      return noText ? "8px" : "8px 16px"
    case "normal":
      return noText ? "16px" : "16px 30px"
    case "big":
      return noText ? "24px" : "24px 38px"
  }
}
